import { render, staticRenderFns } from "./EnacProcedureAtpDafEditCompetenciesView.vue?vue&type=template&id=01859b4a"
import script from "./EnacProcedureAtpDafEditCompetenciesView.vue?vue&type=script&lang=js"
export * from "./EnacProcedureAtpDafEditCompetenciesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports